import { SVGProps } from 'react';

interface Props {
  props?: SVGProps<SVGSVGElement>;
  size?: string | number;
  muted?: boolean;
}

const Design = ({ props, size = 16, muted = false }: Props) => {
  const dark = muted ? '#5d5d5d' : '#781777';
  const light = muted ? '#6d6d6d' : '#d82ee0';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path fill={dark} d="M5 0h11v11H5z" />
      <path fill={light} d="M0 5h11v11H0z" />
    </svg>
  );
};

export default Design;
